/**
 * Centre Page FAQ accordion (vanilla JS).
 */
(function () {
	'use strict';

	/**
	 * Toggle panel visibility for legacy infobox accordion markup.
	 *
	 * @param {HTMLElement} root FAQ section root.
	 * @param {HTMLElement} toggle Clicked title element.
	 */
	function toggleLegacyItem(root, toggle) {
		var section = toggle.nextElementSibling;
		var arrow = toggle.querySelector('.arrow-icon');

		if (!section || !section.classList.contains('text')) {
			return;
		}

		var isOpen = section.classList.contains('active');

		root.querySelectorAll('.text').forEach(function (panel) {
			panel.classList.remove('active');
			panel.style.display = 'none';
		});

		root.querySelectorAll('.arrow-icon').forEach(function (icon) {
			icon.style.transform = 'rotate(0deg)';
		});

		if (!isOpen) {
			section.classList.add('active');
			section.style.display = 'block';
			if (arrow) {
				arrow.style.transform = 'rotate(180deg)';
			}
		}
	}

	/**
	 * Bind legacy infobox accordion toggles.
	 *
	 * @param {HTMLElement} root FAQ section root.
	 */
	function initLegacyAccordion(root) {
		var toggles = root.querySelectorAll('.hi-js');

		toggles.forEach(function (toggle) {
			toggle.addEventListener('click', function () {
				toggleLegacyItem(root, toggle);
			});
		});

		root.querySelectorAll('.infobox section.active').forEach(function (panel) {
			panel.style.display = 'block';
		});
	}

	/**
	 * Bind structured FAQ item toggles.
	 *
	 * @param {HTMLElement} section FAQ section root.
	 */
	function initStructuredAccordion(section) {
		var toggles = section.querySelectorAll('[data-faq-toggle]');

		toggles.forEach(function (btn) {
			btn.addEventListener('click', function () {
				var item = btn.closest('.faq-item');
				var answer = item ? item.querySelector('.faq-answer') : null;

				if (!item || !answer) {
					return;
				}

				var isOpen = item.classList.contains('open');

				if (isOpen) {
					item.classList.remove('open');
					btn.setAttribute('aria-expanded', 'false');
					answer.setAttribute('hidden', '');
				} else {
					item.classList.add('open');
					btn.setAttribute('aria-expanded', 'true');
					answer.removeAttribute('hidden');
				}
			});
		});
	}

	function init() {
		var section = document.querySelector('[data-centre-faq]');
		if (!section) {
			return;
		}

		if (section.querySelector('.hi-js')) {
			initLegacyAccordion(section);
		}

		initStructuredAccordion(section);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
